import React, { useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";

/**
 * SectorSuggest — small button that calls Claude to suggest 1-3 sectors
 * from the founder's description / one-line-pitch. On click it renders a
 * dropdown of picks; clicking one calls onPick(sector).
 */
export default function SectorSuggest({ description, onePitch, currentSector, onPick }) {
  const [busy, setBusy] = useState(false);
  const [picks, setPicks] = useState(null);

  const run = async () => {
    const desc = (description || "").trim();
    const pitch = (onePitch || "").trim();
    if (!desc && !pitch) {
      toast.info("Fill your one-line pitch or a short description first — the AI needs something to read.");
      return;
    }
    setBusy(true);
    try {
      const res = await api.post("/startup/ai/sector-suggest", {
        description: desc || pitch,
        one_line_pitch: pitch,
        current_sector: currentSector,
      });
      setPicks(res.data.suggestions || []);
    } catch (e) {
      toast.error("Couldn't generate suggestions.");
    } finally { setBusy(false); }
  };

  return (
    <div className="mt-1" data-testid="sector-suggest-wrap">
      <button
        type="button"
        onClick={run}
        disabled={busy}
        className="inline-flex items-center gap-1.5 text-[11px] text-emerald-700 hover:text-emerald-800 font-mono uppercase tracking-widest disabled:opacity-50"
        data-testid="sector-suggest-btn"
      >
        {busy ? <Loader2 size={11} className="animate-spin" /> : <Sparkles size={11} />}
        {busy ? "Thinking…" : "Suggest with AI"}
      </button>
      {picks && picks.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-1.5" data-testid="sector-suggest-list">
          {picks.map((p) => (
            <button
              key={p.sector}
              type="button"
              onClick={() => { onPick?.(p.sector); toast.success(`Sector set to ${p.sector}.`); setPicks(null); }}
              className="text-xs px-2 py-1 rounded-full border border-emerald-300 bg-emerald-50 text-emerald-800 hover:bg-emerald-100 transition-colors"
              title={p.rationale}
              data-testid={`sector-suggest-pick-${p.sector}`}
            >
              {p.sector} <span className="opacity-60">· {Math.round((p.confidence || 0) * 100)}%</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
